import type { ReactNode } from "react";
import type { AlignProp } from "../components";

export interface NavBarGroupProps {
  align?: AlignProp;
  children?: ReactNode;
  full?: boolean;
}

export function NavBarGroup({
  align = "center",
  children,
  full,
}: NavBarGroupProps) {
  return (
    <div className="NavBarGroup" data-align={align} data-full={full}>
      {children}
    </div>
  );
}
